<template>
  <div class="made-by-component text--center pb-3">
    <span>
      ©2021. Made by
      <a href="https://libaedu.com" class="link">Libaedu</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'made-by',
}
</script>

<style lang="scss">
.made-by-component {
  position: absolute;
  bottom: 0;
  width: 98%;
}
</style>
